export default __webpack_public_path__ + "static/media/logo2s.23aa96e6.png";